import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import LogoHeaderLight from './../images/logos/logoLight.svg';
import TitleAlt from '../atoms/TitleAlt.jsx'
import Cv from './../recourses/cv-eliudcesar.pdf'
import Menu from './../images/images-master/icons-svg/menu-hamburguesa.svg'

class Header extends Component {
    constructor(props) {
        super(props) 

        this.funtionHeader = this.funtionHeader.bind(this)
    }

    funtionHeader() {
        const menuResponsiveMobile = document.getElementById('main-menu-mobile')
        menuResponsiveMobile.classList.toggle('active')

        const menuHamburguesa = document.getElementById('logo-hamburguesa')
        menuHamburguesa.classList.toggle('active')
    }

    render() {
        return (
            <header className="container-header">

                <section className="container-img-logo">
                    <NavLink to="/" className="image-header">
                        <img src={LogoHeaderLight} alt={TitleAlt}/>
                    </NavLink>
                </section>
                
                <section className="container-menu-hamburguesa" onClick={this.funtionHeader}> <img id="logo-hamburguesa" className="logo-hamburguesa" src={Menu} alt={TitleAlt}/> </section>
                
                <ul id="main-menu-mobile" className="container-text-links">
                    <li><NavLink  className="list-header" to="/contacto">Contacto</NavLink></li>
                    <li><a  className="list-header" target="-blank" href="https://linkedin.com/in/eliud-cesar">Linkedin</a></li>
                    <li><p className="list-header"><a download href={Cv} >CV - (curriculum vitae)</a></p></li>
                </ul>
            </header>
        )
    }
}

export default Header;